import { ApiErrorCode as t, errorMapping as o } from "./constants.js";
const E = (r, a) => ({ [r]: { status: o[r].status, message: a, data: o[r].data } }), s = (r) => E(t.ENTITY_NOT_FOUND, r), T = (r) => E(t.ENTITY_ALREADY_EXISTS, r), e = (r) => E(t.ENTITY_IN_USE, r), _ = (r) => E(t.FIELD_CANNOT_BE_UPDATED, r), c = (r) => E(t.EXPECTATION_FAILED, r), i = (r) => E(t.REQUEST_BODY_VALIDATION, r), A = (r) => E(t.AUTH_REJECTED, r);
export {
  T as alreadyExistsError,
  A as authRejectedError,
  c as expectationFailedError,
  _ as fieldCannotBeUpdatedError,
  e as inUseError,
  s as notFoundError,
  i as requestValidationError
};
//# sourceMappingURL=contract.js.map
